import { useTheme } from "../../lib/theme-context"

interface ThemeLogoProps {
  className?: string;
  alt?: string;
}

export function ThemeLogo({ className = "h-8", alt = "Nosh" }: ThemeLogoProps) {
  const { theme } = useTheme();
  
  const logoSrc = theme === 'dark' ? '/nosh-new-wh.png' : '/new-new-bk.png';
  
  return (
    <img 
      src={logoSrc} 
      alt={alt}
      className={className}
    />
  );
} 